import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';

export default class DealerService extends Singleton<DealerService> {
  public getOrganizationDealer = async (dealerId: number) => {
    const client = await ApiService();
    let organizationDealerResponse;

    try {
      organizationDealerResponse = await client.apis.organization.getDealer({
        id: dealerId,
        request: {
          request: {}
        }
      });
    } catch (e) {
      // handle exception
    }

    return organizationDealerResponse?.body;
  };
}
